import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index.js'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css';
import request from "@/utils/request";
Vue.prototype.request = request


import  VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.use(ElementUI)
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
